export default {"src":"/_next/static/media/ideas.ff8f3d69.svg","height":25,"width":17,"blurWidth":0,"blurHeight":0};